import React, { Fragment } from 'react';
import { Spacer, Text } from '@ontruck/orc';
import { FormatPrice } from 'utils/format';
import arrowRenderer from './arrowRenderer';

const ShipperOrderId = ({ id, color, isLast }) => (
  <Fragment>
    <Text color={color} key={id}>
      S{id}
    </Text>
    {!isLast && (
      <span style={{ marginLeft: 0, marginRight: 4 }}>
        <Text color={color}>,</Text>
      </span>
    )}
  </Fragment>
);

const ShipperOrderIds = ({ ids = [], getColor }) =>
  ids.map((id, index) => (
    <ShipperOrderId key={id} color={getColor(id)} id={id} isLast={index === ids.length - 1} />
  ));

const improvedOffersRenderer = ({
  changes: { driver_name_after, cost, currency, original_shipper_order_ids, new_shipper_order_ids },
  ...props
}) => {
  const fromIds = original_shipper_order_ids || [];
  const toIds = new_shipper_order_ids || [];

  const intersectedIds = fromIds.filter((x) => toIds.includes(x));

  const renderFrom = () => <ShipperOrderIds ids={fromIds} getColor={() => 'grey500'} />;

  const renderTo = () => (
    <ShipperOrderIds
      ids={toIds}
      getColor={(id) => (intersectedIds.includes(id) ? 'grey500' : 'grey900')}
    />
  );
  return (
    <Spacer {...props}>
      {!!driver_name_after && (
        <Text color="grey800" display="block">
          {driver_name_after}
        </Text>
      )}
      {!!cost && (
        <Text color="grey800" display="block">
          <FormatPrice currency={currency} value={cost} />
        </Text>
      )}
      {!!fromIds?.length && !!toIds?.length && (
        <div>
          <>{arrowRenderer(renderFrom(), renderTo())}</>
        </div>
      )}
    </Spacer>
  );
};

export default improvedOffersRenderer;
